module.exports = __webpack_public_path__ + "img/vr.c245bca1.jpeg";